'use strict'

import { getPreparedConfiguration } from '../../components/ConfigurableObjectUtils.js'
import FilesGroupsContainer from '../../components/File/FilesGroupsContainer.js'
import ReportMaterialsGroups from './ReportMaterials/ReportMaterialsGroups.js'
import ReportManager from './ReportManager.js'
import FilesGroup from '../../components/File/FilesGroup.js'

export const ADDITIONAL_FIELDS_CONFIGURATIONS = {
  // вычисляемые => НЕ отправлять на сервер
  yandexExecutors: {
    type: 'string',
    computed: true
  },
  yandexExecutor: {
    type: 'string',
    computed: true
  },
  yandexExecutorJournalRecords: {
    type: 'string',
    computed: true
  },
  yandexTasks: {
    type: 'string',
    computed: true
  }
}

export function convertReportFromServer (sourceReport, user) {
  sourceReport.rushWorkMode = !!sourceReport.rushWorkMode
  sourceReport.supTaskChangedNotify = sourceReport.supTaskChangedNotify === true

  if (!sourceReport.workPackages) {
    sourceReport.workPackages = []
  }
  if (!sourceReport.workPackagesContractor) {
    sourceReport.workPackagesContractor = []
  }

  // Контракт (проект)
  if (sourceReport.reports) {
    sourceReport.reports.forEach(reportItem => {
      reportItem.supTaskChangedNotify = reportItem.supTaskChangedNotify === true
      reportItem.project = reportItem.project || null

      // Поля необходимые для отчётов в мультиотчёте
      reportItem.actionsAccess = sourceReport.actionsAccess || {}
      reportItem.brigadeId = sourceReport.brigadeId || null
      reportItem.brigadeName = sourceReport.brigadeName || null
      reportItem.brigadeIsContractor = sourceReport.brigadeIsContractor
      reportItem.bpStateId = sourceReport.bpStateId || reportItem.bpStateId || null
      reportItem.riBrigades = sourceReport.riBrigades || []
    })
  } else {
    sourceReport.project = sourceReport.project || null

    if (sourceReport.multiReport) { // получен отдельный отчёт из сводного отчёта => запрещаем в нем любые операции, все делается через сводный
      sourceReport.actionsAccess = {}
    }
  }

  // Спецтехника
  if (!sourceReport.forkliftTrucks) {
    sourceReport.forkliftTrucks = []
  }
  sourceReport.forkliftTrucksAbsent = !!sourceReport.forkliftTrucksAbsent
  sourceReport.forkliftTrucksComment = sourceReport.forkliftTrucksComment || null

  sourceReport.departureActive = sourceReport.departureFinished === false
  sourceReport.hasDeparture = sourceReport.departureFinished != null // sourceReport.departureNumber !== 0

  if (!sourceReport.documents) {
    sourceReport.documents = []
  }

  sourceReport.showCityMessengerBotSection = sourceReport.showCityMessengerBotSection != null ? sourceReport.showCityMessengerBotSection : null
  sourceReport.isCityMessengerBotSuccessSend = sourceReport.isCityMessengerBotSuccessSend != null ? sourceReport.isCityMessengerBotSuccessSend : null
  sourceReport.cityMessengerBotSendTime = sourceReport.cityMessengerBotSendTime != null ? sourceReport.cityMessengerBotSendTime : null
  sourceReport.cityMessengerBotRequestStatus = sourceReport.cityMessengerBotRequestStatus || null
  sourceReport.cityMessengerBotClosingCommentText = sourceReport.cityMessengerBotClosingCommentText || null
  sourceReport.cityMessengerBotRequestId = sourceReport.cityMessengerBotRequestId != null ? sourceReport.cityMessengerBotRequestId : null

  if (sourceReport.reports) {
    sourceReport.reports.forEach(multiReportItem => {
      Object.defineProperty(multiReportItem, '_multiReport', {
        value: sourceReport,
        writable: false,
        enumerable: false,
        configurable: true
      })
    })
  }

  if (sourceReport.reports) {
    sourceReport.reports.forEach(multiReportItem => {
      prepareIndividualReport(multiReportItem)
    })
  } else {
    prepareIndividualReport(sourceReport)
  }

  const sourceConfig = {
    objectId: sourceReport.id,
    uploadURL: '/service/delta/report/document/upload',
    removeURL: '/service/delta/report/document/deleteFromObject'
  }

  sourceReport.filesGroupsContainers = {
    guiImgFiles: new FilesGroupsContainer({
      sourceConfig: Object.assign({
        progressLabelPart: 'изображений'
      }, sourceConfig)
    }),
    guiDocFiles: new FilesGroupsContainer({
      sourceConfig: Object.assign({
        progressLabelPart: 'вложений'
      }, sourceConfig)
    })
  }
  // sourceReport.filesGroupsContainers.guiImgFiles.addFilesGroup(new ReportFilesGroup({ categoryKey: 'other', title: 'ДРУГОЕ' }))
  // sourceReport.filesGroupsContainers.guiDocFiles.addFilesGroup(new ReportFilesGroup({ categoryKey: 'other', title: 'ДРУГОЕ' }))

  if (!sourceReport.photoCategories) {
    sourceReport.photoCategories = []
  }
  sourceReport.activePhotoCategories = sourceReport.photoCategories.map(category => category.key)
  sourceReport.requiredPhotoCategories = sourceReport.photoCategories.filter(category => category.required).map(category => category.key)
  sourceReport.photoUploadConfig = sourceReport.photoUploadConfig || null

  if (user.hasSystemRoleStrict('publicationRead') || user.restrictedAccess) {
    const activePhotoCategoriesKeys = [
      'beforeWorkExecution',
      'afterWorkExecution'
    ]
    sourceReport.activePhotoCategories = sourceReport.activePhotoCategories.filter(key => activePhotoCategoriesKeys.includes(key))
  }

  // sourceReport.workPackages.workTypes
  // sourceReport.workTypes
  // __ technologicalOperations
  // ____ workResultsTypes
  // ______ resultValues
  sourceReport.workTypesToRemove = []
  prepareReportWorks(sourceReport.workTypes, sourceReport.workPackages, sourceReport, 'standard')
  sourceReport.workTypesToRemoveContractor = []
  prepareReportWorks(sourceReport.workTypesContractor, sourceReport.workPackagesContractor, sourceReport, 'contractor')

  sourceReport.operationTimingsActive = !!sourceReport.operationTimingsActive
  sourceReport.operationTimings = sourceReport.operationTimings || []

  // Замечания
  if (!sourceReport.remarks) {
    sourceReport.remarks = []
  }
  if (!sourceReport.imagesRemarks) {
    sourceReport.imagesRemarks = []
  }
  if (!sourceReport.commonRemark) {
    sourceReport.commonRemark = {
      active: false,
      done: false,
      important: false,
      code: 'commonRemark',
      comment: null
    }
  }

  prepareReportRoles(sourceReport, user)
  prepareActionsAccess(sourceReport)

  Object.defineProperty(sourceReport, '_reportManager', {
    value: new ReportManager(sourceReport),
    writable: false,
    enumerable: false,
    configurable: true
  })

  sourceReport._configuration = getPreparedConfiguration(sourceReport.configuration, ADDITIONAL_FIELDS_CONFIGURATIONS)
  let configuration = sourceReport.configuration
  if (user.hasSystemRoleStrict('publicationRead') || user.restrictedAccess) {
    if (!configuration) {
      configuration = {}
    }
    if (!configuration.configurableFields) {
      configuration.configurableFields = []
    }
    const excludedFieldsKeys = ['remarks', 'serviceObjectPhoto', 'project', 'executorSection', 'forkliftTrucks', /* 'address', */
      'initiatorRequestsSection', 'initiatedRequestsSection', 'auditRemarksSection', 'maintenanceNotesSection',
      'docFilesSection', /* 'applicantDescription', */
      'flawsSection', 'checkListSection', 'checkListContractorSection', 'historySection', 'reworksSection',
      'materials',
      // ===
      'stateHeaderLabel'
    ]
    if (user.hasSystemRoleStrict('publicationRead') || user.strictRestrictedAccess) {
      excludedFieldsKeys.push('comment')
    }
    if (user.strictRestrictedAccess) {
      excludedFieldsKeys.push('address', 'applicantDescription')
    }

    for (const excludedFieldKey of excludedFieldsKeys) {
      configuration.configurableFields.push({
        key: excludedFieldKey,
        hidden: true
      })
    }
  }

  sourceReport._configuration = getPreparedConfiguration(configuration, ADDITIONAL_FIELDS_CONFIGURATIONS)
  sourceReport.isFieldIncluded = function (fieldKey) {
    return !this._configuration.excludedFields.includes(fieldKey)
  }
  sourceReport.hasAdditionalField = function (fieldKey) {
    return this._configuration.hasAdditionalField(fieldKey)
  }

  if (sourceReport.reports) {
    sourceReport.reports.forEach(reportItem => {
      reportItem.isFieldIncluded = sourceReport.isFieldIncluded.bind(sourceReport)
    })
  }

  if (sourceReport.hasAdditionalField('yandexExecutors')) {
    sourceReport.yandexExecutor = sourceReport.yandexExecutor || null
    sourceReport.yandexExecutorJournalRecords = sourceReport.yandexExecutorJournalRecords || []
  }
  if (sourceReport.hasAdditionalField('yandexTasks')) {
    sourceReport.yandexTasks = sourceReport.yandexTasks || []
  }

  return sourceReport
}

function prepareIndividualReport (report) {
  report.demountings = []
  report.mountings = []
  report.debits = []
  report.consumptions = []

  report.demountingsFromOtherDepartures = []
  report.mountingsFromOtherDepartures = []

  Object.defineProperty(report, '_materialsGroups', {
    value: new ReportMaterialsGroups(report),
    writable: false,
    enumerable: false,
    configurable: true
  })
}

export function prepareReportWorks (workTypes, workPackages, report, executorTypeKey) {
  const allWorks = [...workTypes]
  for (let i = 0; i < workPackages.length; i++) {
    workPackages[i].workTypes.forEach((work) => {
      work.uniqueKey = workPackages[i].id
      allWorks.push(work)
    })
  }

  allWorks.forEach(work => {
    prepareReportWork(work, report, executorTypeKey)

    Object.defineProperties(work, {
      _initial: {
        value: JSON.parse(JSON.stringify(getClearedWork(work))),
        writable: false,
        enumerable: false,
        configurable: true
      },
      hasChanges: {
        value: function () {
          const clearedWork = getClearedWork(work)
          return JSON.stringify(work._initial) !== JSON.stringify(clearedWork)
        },
        writable: false,
        enumerable: false,
        configurable: true
      }
    })
  })
}

export function prepareReportWork (work, report, executorTypeKey) {
  if (work.uniqueKey == null) {
    work.uniqueKey = ''
  }
  work.uniqueKey += '_' + work.id

  Object.defineProperty(work, 'executorTypeKey', {
    value: executorTypeKey || null,
    writable: false,
    enumerable: false,
    configurable: true
  })

  for (const technologicalOperation of work.technologicalOperations) {
    technologicalOperation.uniqueKey = work.uniqueKey + '_' + technologicalOperation.id + '_' + (technologicalOperation.index || 0)
    Object.defineProperty(technologicalOperation, '_work', {
      value: work,
      writable: false,
      enumerable: false,
      configurable: true
    })

    technologicalOperation.hide = false // вместо $set в ReportCheckLis`tWorkType
    // TODO Проверка наличия результата (вычисляемое свойство)
    // technologicalOperation.hasResult - вместо ReportChackListTechnologicalOperationHasResult.js => technologicalOperationHasResult

    for (const workResultsType of technologicalOperation.workResultsTypes) {
      if (workResultsType && workResultsType.resultValues) {
        workResultsType.uniqueKey = technologicalOperation.uniqueKey + '_' + workResultsType.id
        Object.defineProperty(workResultsType, '_technologicalOperation', {
          value: technologicalOperation,
          writable: false,
          enumerable: false,
          configurable: true
        })

        // из ReportCheckListWorkResultsTypes.vue => created
        for (const resultValue of workResultsType.resultValues) {
          resultValue.uniqueKey = workResultsType.uniqueKey + '_' + resultValue.id
          Object.defineProperty(resultValue, '_workResultsType', {
            value: workResultsType,
            writable: false,
            enumerable: false,
            configurable: true
          })

          if (resultValue.objectValue === undefined && resultValue.objectType) {
            resultValue.objectValue = null
          }

          // TODO Проверка наличия результата (вычисляемое свойство)
          // resultValue.hasResult - из ReportChackListTechnologicalOperationHasResult.js => technologicalOperationHasResult

          // Инициализируем значения
          // ? if (!resultValue.dependency || !resultValue.dependency.hide) {}
          if (resultValue.fieldType == 'combobox') {
            // из ReportCheckListCombobox
            if (!resultValue.multiselect) {
              if (Array.isArray(resultValue.value)) {
                resultValue.value = resultValue.value[0]
              }
              if (Array.isArray(resultValue.objectValue)) {
                resultValue.objectValue = resultValue.objectValue[0]
              }
            }
          } else if (resultValue.fieldType == 'checkbox') {
            // ---
          } else if (resultValue.fieldType == 'object') {
            // ---
          } else if (resultValue.fieldType == 'ref') {
            // ---
          } else if (resultValue.fieldType == 'text') {
            // ---
          } else if (resultValue.fieldType == 'location') {
            // из ReportCheckListLocation
            if (resultValue.value == null) {
              resultValue.value = [[null, null]]
            }
            // number to string with fixed(6)
            resultValue.value[0][0] = prepareCoordinateValue(resultValue.value[0][0])
            resultValue.value[0][1] = prepareCoordinateValue(resultValue.value[0][1])
            if (resultValue.objectValue === null) {
              resultValue.objectValue = [[null, null]]
            }
          } else if (resultValue.fieldType == 'number') {
            // ---
          } else if (resultValue.fieldType == 'file' || resultValue.fieldType == 'image') {
            // из ReportCheckListFile
            const filesProperty = resultValue.fieldType === 'image' ? 'guiImgFiles' : 'guiDocFiles'
            const filesGroupsContainer = report.filesGroupsContainers[filesProperty]
            const key = resultValue.uniqueKey
            const filesGroup = new FilesGroup({
              categoryKey: 'checkList' + resultValue.fieldType,
              readonly: false,
              key: key,
              props: {
                resultKey: key
              }
            })

            filesGroupsContainer.addFilesGroup(filesGroup)
            pushDocumentsToWorkResultValue(report, filesGroup, resultValue, 'value') // resultValue.value
          } else if (resultValue.fieldType == 'formdata' && resultValue.formType === 'camMetroResult') {
            const filesProperty = 'guiImgFiles'
            const filesGroupsContainer = report.filesGroupsContainers[filesProperty]

            const onAddCam = (tgId, camInfo) => {
              let tgGroup = resultValue.value.find(tgGroup => tgGroup.tgId === tgId)
              if (!tgGroup) {
                tgGroup = {
                  tgId: tgId,
                  subgroups: []
                }
                resultValue.value.push(tgGroup)
              }

              camInfo.inTSubgroupNumber = camInfo.inTSubgroupNumber || -1
              let subGroup = tgGroup.subgroups.find(subgroup => subgroup.subgroupId === camInfo.inTSubgroupNumber)
              if (!subGroup) {
                subGroup = {
                  subgroupId: camInfo.inTSubgroupNumber,
                  subgroupPhoto: [],
                  cams: []
                }
                tgGroup.subgroups.push(subGroup)
              }

              const cam = {
                camId: camInfo.object,
                cameraIp: camInfo.cameraIp || null,
                deskId: camInfo.request,
                inTgroupNumber: camInfo.inTgroupNumber,
                inTSubgroupNumber: camInfo.inTSubgroupNumber,
                otherDeskIds: camInfo.otherRequests || [],
                comment: null,
                photoBefore: [],
                photoAfter: []
              }
              subGroup.cams.push(cam)
            }

            if (!resultValue.value || resultValue.value.length === 0) {
              resultValue.value = []

              if (report.externalCameraTourniquetGroups) {
                Object.keys(report.externalCameraTourniquetGroups).forEach(tgId => {
                  const tgGroup = report.externalCameraTourniquetGroups[tgId]
                  const requestType = report.requestType && report.requestType[report.id] || null

                  tgGroup.filter(camInfo => {
                    if (requestType === 'kmto1StationFP') {
                      return camInfo.cameraType === 'bioFacePay'
                    } else if (requestType === 'kmto1StationBio') {
                      return camInfo.cameraType === 'bio'
                    } else {
                      return true
                    }
                  }).forEach(camInfo => {
                    if (camInfo.object && camInfo.isActual) {
                      onAddCam(tgId, camInfo)
                    }
                  })
                })
              }
            }

            if (resultValue.value && resultValue.value.length) {
              if (report.externalCameraTourniquetGroups) {
                Object.keys(report.externalCameraTourniquetGroups).forEach(tgId => {
                  const tgGroup = report.externalCameraTourniquetGroups[tgId]
                  tgGroup.forEach(camInfo => {
                    if (camInfo.object) {
                      const tgGroup = resultValue.value.find(tgGroup => tgGroup.tgId === tgId)
                      // Старая конфигурация без подгрупп -> 1 подгруппа с subgroupId=-1
                      if (tgGroup && tgGroup.cams) {
                        tgGroup.subgroups = []
                        tgGroup.subgroups.push({
                          subgroupId: -1,
                          subgroupPhoto: tgGroup.tgPhoto,
                          cams: tgGroup.cams
                        })

                        // Для старых результатов проставляем новые поля
                        const cam = tgGroup.cams.find(cam => cam.camId === camInfo.object)
                        if (cam) {
                          Object.defineProperty(cam, 'otherDeskIds', {
                            value: camInfo.otherRequests || [],
                            writable: false,
                            enumerable: false,
                            configurable: true
                          })
                          Object.defineProperty(cam, 'inTgroupNumber', {
                            value: camInfo.inTgroupNumber || null,
                            writable: false,
                            enumerable: false,
                            configurable: true
                          })
                          Object.defineProperty(cam, 'cameraIp', {
                            value: camInfo.cameraIp || null,
                            writable: false,
                            enumerable: false,
                            configurable: true
                          })
                        }
                      }
                    }
                  })
                })
              }

              resultValue.value.forEach(tgGroup => {
                tgGroup.opened = true
                tgGroup.subgroups.forEach(subgroup => {
                  const key = `${resultValue.uniqueKey}_${tgGroup.tgId}_${subgroup.subgroupId}`

                  const filesGroup = new FilesGroup({
                    categoryKey: 'checkListCamMetro',
                    key: key,
                    props: {
                      resultKey: key,
                      tgId: tgGroup && tgGroup.tgId || null,
                      subgroupId: subgroup && subgroup.subgroupId || null
                    }
                  })
                  filesGroupsContainer.addFilesGroup(filesGroup)

                  const fixUndefinedInResultKey = resultKey => {
                    if (!resultKey) {
                      return resultKey
                    }
                    const parts = resultKey.split('_')
                    // technologicalOperation.index
                    if (parts[3] === 'undefined') {
                      parts[3] = '0'
                    }
                    return parts.join('_')
                  }

                  pushDocumentsToWorkResultValue(report, filesGroup, subgroup, 'subgroupPhoto', document =>
                    document.additional && !document.additional.camId && fixUndefinedInResultKey(document.additional.resultKey) === key
                  ) // tgGroup.tgPhoto -> subgroup.subgroupPhoto

                  subgroup.cams.forEach(cam => {
                    const types = ['before', 'after']
                    types.forEach(type => {
                      const key = `${resultValue.uniqueKey}_${type}_${cam.camId}`
                      const filesGroup = new FilesGroup({
                        categoryKey: 'checkListCamMetro',
                        key: key,
                        props: {
                          resultKey: key,
                          camId: cam.camId || null,
                          deskId: cam.deskId || null,
                          subgroupId: subgroup && subgroup.subgroupId || null,
                          tgId: tgGroup.tgId || null,
                          type
                        }
                      })
                      filesGroupsContainer.addFilesGroup(filesGroup)

                      const photoProperty = type === 'before' ? 'photoBefore' : 'photoAfter'
                      pushDocumentsToWorkResultValue(report, filesGroup, cam, photoProperty, document => document.additional && fixUndefinedInResultKey(document.additional.resultKey) === filesGroup.key) // cam[photoProperty]
                    })
                  })
                })
              })
            }
          } else if (resultValue.fieldType == 'formdata' && resultValue.formType === 'remontJResult') {
            const filesProperty = 'guiImgFiles'
            const filesGroupsContainer = report.filesGroupsContainers[filesProperty]

            if (resultValue.value && resultValue.value.length) {
              resultValue.value.forEach(rec => {
                const key = `${resultValue.uniqueKey}_${rec.time}`
                const filesGroup = new FilesGroup({
                  categoryKey: 'checkListRemontJResult',
                  key: key,
                  props: {
                    resultKey: key
                  }
                })
                filesGroupsContainer.addFilesGroup(filesGroup)

                pushDocumentsToWorkResultValue(report, filesGroup, rec, 'photo', null, false) // rec.photo
              })
            } else {
              resultValue.value = []
            }
          } else if (resultValue.fieldType == 'formdata' && resultValue.formType === 'ptoSmeta') {
            const filesProperty = 'guiImgFiles'
            const filesGroupsContainer = report.filesGroupsContainers[filesProperty]

            if (resultValue.value && resultValue.value.length) {
              resultValue.value.forEach(rec => {
                const key = `${resultValue.uniqueKey}_${rec.time}`
                const filesGroup = new FilesGroup({
                  categoryKey: 'checkListOutlayResult',
                  key: key,
                  props: {
                    resultKey: key
                  }
                })
                filesGroupsContainer.addFilesGroup(filesGroup)

                pushDocumentsToWorkResultValue(report, filesGroup, rec, 'photo') // rec.photo
              })
            } else {
              resultValue.value = []
            }
          } else if (resultValue.fieldType == 'formdata' && resultValue.formType === 'soDirTable') {
            if (!resultValue.value) {
              resultValue.value = {
                dirNum: [],
                dirType: [],
                lights: [],
                countdownRed: [],
                countdownGreen: [],
                regime: []
              }
            }
          } else if (resultValue.fieldType == 'formdata' && resultValue.formType === 'soStands') {
            const filesProperty = 'guiImgFiles'
            const filesGroupsContainer = report.filesGroupsContainers[filesProperty]

            if (resultValue.value && resultValue.value.length) {
              resultValue.value.forEach(stand => {
                const photoGroups = ['photo', 'photoQr']
                photoGroups.forEach(photoGroup => {
                  const key = `${resultValue.uniqueKey}_${photoGroup}_${stand.id}`
                  const filesGroup = new FilesGroup({
                    categoryKey: 'checkListSoStands',
                    key: key,
                    props: {
                      resultKey: key
                    }
                  })
                  filesGroupsContainer.addFilesGroup(filesGroup)

                  pushDocumentsToWorkResultValue(report, filesGroup, stand, photoGroup) // stand[photoGroup]
                })
              })
            } else {
              resultValue.value = []
            }
          } else if (resultValue.fieldType == 'formdata' && resultValue.formType === 'auditDtResults') {
            // из ReportCheckListAuditDt
            resultValue.onAddDirection = function (inventoName, auditdata) {
              const direction = {
                audit: {
                  name: 'Направление ' + (this.value.directions.length + 1),
                  data: auditdata || [null, null, null]
                },
                invento: {
                  name: inventoName,
                  data: [null, null, null]
                },
                tperiods: [null, null, null],
                loading: false
              }

              if (this.value.tperiods) {
                direction.tperiods = JSON.parse(JSON.stringify(this.value.tperiods))
              }
              this.value.directions.push(direction)
            }

            if (!resultValue.value || !resultValue.value.directions) {
              resultValue.value = {}
              resultValue.value.isGeneralTperiods = true
              resultValue.value.directions = []
              resultValue.value.tperiods = [null, null, null]

              const directionsCount = 2
              for (let i = 0; i < directionsCount; i++) {
                resultValue.onAddDirection(null, null)
              }
            }
          } else if (resultValue.fieldType == 'formdata' && (resultValue.formType === 'cableMount' || resultValue.formType === 'cableDemount')) {
            // из ReportCheckListCable
            resultValue.materialsSourceReport = getMaterialsSourceReport(report, work)

            if (!resultValue.value) {
              resultValue.value = {}
            }
            if (!resultValue.value[resultValue.materialsSourceReport.key]) {
              resultValue.value[resultValue.materialsSourceReport.key] = []
            }
          } else if (resultValue.fieldType == 'formdata' && resultValue.formType === 'valueConstruction') {
            // из ReportCheckListConstruction
            if (!resultValue.value) {
              resultValue.value = []
            }
            if (!resultValue.value.find(val => val.reportId === report.id)) {
              resultValue.value.push({ reportId: report.id, reportName: report.name, value: null })
            }
          } else {
            // TODO ???
          }
        }
      }
    }
  }
}

function pushDocumentsToWorkResultValue (report, filesGroup, valueParent, valueProperty, inclusionCheckFn, allowInclusionFix) {
  if (!valueParent[valueProperty]) {
    valueParent[valueProperty] = []
  }
  if (report.documents) {
    const documentsIds = valueParent[valueProperty]

    report.documents.forEach(document => {
      pushDocumentToWorkResultValue(filesGroup, document, documentsIds, inclusionCheckFn, allowInclusionFix)
    })
  }
}

function pushDocumentToWorkResultValue (filesGroup, document, documentsIds,
  inclusionCheckFn = (document) => document.additional && document.additional.resultKey === filesGroup.key,
  allowInclusionFix = true
) {
  if (document.category === filesGroup.categoryKey) {
    let included = documentsIds.includes(document.id)
    if (allowInclusionFix && !included && inclusionCheckFn && inclusionCheckFn(document)) {
      documentsIds.push(document.id)
      console.log('Fix document binding to work result value. Document id=' + document.id)
      included = true
    }
    const duplicatesAmount = documentsIds.filter(id => id === document.id).length
    const addedDuplicatesAmount = filesGroup.files.filter(file => file.document.id === document.id).length
    if (included && duplicatesAmount > addedDuplicatesAmount) {
      let i = 0
      while (i < duplicatesAmount - addedDuplicatesAmount) {
        filesGroup.pushFile(document)
        i++
      }
      document._isWorkDocument = true
    }
  }
}

function prepareReportRoles (report, user) {
  if (!user) {
    return
  }

  if (!report.actionsAccess) {
    report.actionsAccess = {}
  }

  const roles = user.roles || {}
  const roleAdminOrRoot = user.hasRole('admin')
  const roleDispatcherOrHigher = report.actionsAccess.hasDispatcherAccess // user.hasRole('admin', 'dispatcher')
  const roleReportCheckerOrHigher = report.actionsAccess.hasReportCheckerAccess // user.hasRole('admin', 'reportchecker')
  const roleContractorDispatcher = user.hasRoleStrict('contractorDispatcher') && (report.brigadeId != null ? !!report.brigadeIsContractor : !!report.executor && !!report.executor.contractor)

  const hasRoleEmployee = user.hasRoleStrict('brigadier', 'officeemployee', 'brigademember', 'contractorOfficeemployee')
  const roleEmployee = hasRoleEmployee && !roleAdminOrRoot && !roleDispatcherOrHigher && !roleReportCheckerOrHigher && !roleContractorDispatcher

  // TODO delete: report.employee, report.employeeFIO
  const mainExecutor = report.executor
  const roleMainExecutor = !!mainExecutor && mainExecutor.login === user.login
  const roleExecutor = roleMainExecutor || !!report.brigadeEmployees && report.brigadeEmployees.find(employee => employee.login === user.login) != null

  const improvementsExecutorValue = report.improvementsExecutor[user.login]
  const isImprovementsExecutor = improvementsExecutorValue != null
  const isResponsibleImprovementsExecutor = improvementsExecutorValue === true

  const reportRoles = {
    user: user,
    roles: roles,
    roleAdminOrRoot: roleAdminOrRoot,
    roleDispatcherOrHigher: roleDispatcherOrHigher,
    roleReportCheckerOrHigher: roleReportCheckerOrHigher,
    roleContractorDispatcher: roleContractorDispatcher,
    roleEmployee: roleEmployee,
    roleExecutor: roleExecutor,
    roleMainExecutor: roleMainExecutor,
    // improvements
    isImprovementsExecutor,
    isResponsibleImprovementsExecutor,
    hasImprovementsExecutorAccess: roleAdminOrRoot || isImprovementsExecutor,
    hasResponsibleImprovementsExecutorAccess: roleAdminOrRoot || isResponsibleImprovementsExecutor,
    // contractor
    isContractor: user.isContractor,
    isMGSS: user.isMGSS,
    isRSG: user.isRSG,
    // important remarks
    isImportantRemarksAdmin: user.hasRoleStrict('importantRemarksAdmin') || roleAdminOrRoot,
    isImportantRemarksOperator: user.hasRoleStrict('importantRemarksOperator') || roleAdminOrRoot
  }

  Object.defineProperty(report, '_roles', {
    value: reportRoles,
    writable: false,
    enumerable: false,
    configurable: true
  })
}

function prepareActionsAccess (report) {
  const reportRoles = report._roles || {}
  const stateId = report.stateId
  const bpStateId = report.bpStateId

  if (!report.actionsAccess) {
    report.actionsAccess = {}
  }

  Object.defineProperties(report.actionsAccess, {
    // editData
    // editRemarks
    // editMaterials
    // editRequestWorkTypes
    // reinforcementExecutor
    // reworkReportByExecutor
    // changeExecutorOfImprovements
    // setCheckedByDispatcher
    // editGeneralDemounting
    saveRemarksCondition: {
      get: function () {
        return (reportRoles.roleDispatcherOrHigher && (((stateId == 'PR2' || stateId == 'PR3') && bpStateId == 'BS7') || stateId == 'PR4' || stateId == 'PR10' || stateId === 'PR7')) ||
          (reportRoles.roleReportCheckerOrHigher && (stateId == 'PR4' || stateId == 'PR10' || stateId === 'PR7')) ||
          (this.editRemarks && stateId == 'PR9')
      }
    },
    improvementsCommonDisplayCondition: {
      get: function () {
        return (stateId == 'PR4' || stateId == 'PR7' || stateId == 'PR8' || stateId == 'PR9' || stateId == 'PR10') &&
        (reportRoles.roleReportCheckerOrHigher || reportRoles.roleDispatcherOrHigher || this.assigningContractorDispatcher || ((reportRoles.roleEmployee || reportRoles.roleContractorDispatcher) && reportRoles.isImprovementsExecutor))
      }
    },
    saveImprovementsCondition: {
      get: function () {
        // Сохранение отчёта исполнителем доработок (исправление замечаний)
        return (this.improvementsCommonDisplayCondition &&
      (stateId == 'PR9' && reportRoles.hasImprovementsExecutorAccess))
      }
    },
    saveInActiveStateCondition: {
      get: function () {
        // Сохранение отчёта при прохождении основного БП по BS4-8
        return (((bpStateId == 'BS4' || bpStateId == 'BS5' || bpStateId == 'BS6' || bpStateId == 'BS14' || bpStateId == 'BS15') && (reportRoles.roleAdminOrRoot || reportRoles.roleExecutor || reportRoles.roleContractorDispatcher)) ||
        (bpStateId == 'BS6' && reportRoles.roles.dispatcher && (report.closedManually === true || report.bpStateUser === reportRoles.user.login || report.bpStateUser === 'root'))) ||
        ((stateId == 'PR3' || stateId == 'PR11') && this.editData) ||
        !!(this.reinforcementExecutor && this.editData)
      }
    },
    hasAccessSaveChanges: {
      get: function () {
        return this.saveRemarksCondition ||
        this.saveImprovementsCondition ||
        this.saveInActiveStateCondition ||
        (this.improvementsCommonDisplayCondition && stateId !== 'PR8' && (reportRoles.roleAdminOrRoot || this.assigningContractorDispatcher))
      }
    },
    saveAccess: {
      get: function () {
        const saveAccess = this.displaySaveChangesButton || // TODO && !this.disabledSaveChangesButton
        this.PR7_displayVerifiedNoCommentsButton ||
        (this.PR8_displayVerifiedHaveCommentsButton && !this.reworkReportByExecutor) ||
        ((this.PR9_displayFixingProblemsButton || this.PR9_displayFixingProblemsWithReadyToRecheckButton) && stateId === 'PR8') ||
        this.PR10_displayReadyToRecheckButton

        // // PR7
        // const PR7_saveAccess = this.improvementsCommonDisplayCondition &&
        //   ((stateId == 'PR4' || stateId == 'PR10') && reportRoles.roleReportCheckerOrHigher)
        // // PR8
        // // TODO save - condition + !this.report.actionsAccess.reworkReportByExecutor
        // const PR8_saveAccess = !!this.report.actionsAccess.reworkReportByExecutor ||
        //   (this.improvementsCommonDisplayCondition &&
        //     ((stateId == 'PR4' || stateId == 'PR7' || stateId == 'PR10') && (reportRoles.roleDispatcherOrHigher || reportRoles.roleReportCheckerOrHigher)))
        // // PR9
        // // TODO save - condition + stateId === 'PR8'
        // const PR9_saveAccess = this.improvementsCommonDisplayCondition && stateId == 'PR8' &&
        //   ((this.report.actionsAccess && (this.editData || this.editRemarks)) ||
        //     reportRoles.hasResponsibleImprovementsExecutorAccess)
        // // PR10
        // const PR10_saveAccess = this.improvementsCommonDisplayCondition &&
        //   (stateId == 'PR9' && reportRoles.hasResponsibleImprovementsExecutorAccess)

        // const PR7_to_PR10_saveAccess = !!this.report.actionsAccess.reworkReportByExecutor ||
        //   (
        //     this.improvementsCommonDisplayCondition &&
        //     (
        //       ((stateId == 'PR4' || stateId == 'PR10') && reportRoles.roleReportCheckerOrHigher) || // PR7
        //       ((stateId == 'PR4' || stateId == 'PR7' || stateId == 'PR10') && (reportRoles.roleDispatcherOrHigher || reportRoles.roleReportCheckerOrHigher)) || // PR8
        //       (stateId == 'PR8' && ((this.editData || this.editRemarks) ||
        //         reportRoles.hasResponsibleImprovementsExecutorAccess)) || // PR9
        //       (stateId == 'PR9' && reportRoles.hasResponsibleImprovementsExecutorAccess) // PR10
        //     )
        //   )

        return saveAccess
      }
    },
    displaySaveChangesButton: {
      get: function () {
      // const actionsAccess = this.report.actionsAccess
      // const editAnyAccess = !!(this.editData || this.editRemarks)
      // const saveRemarksAccess = (this.saveRemarksCondition && (stateId == 'PR3' || stateId == 'PR4' || stateId == 'PR7' || stateId == 'PR9' || stateId == 'PR10'))
      // const saveImprovementsByAdmin = this.improvementsCommonDisplayCondition && stateId !== 'PR8' && reportRoles.roleAdminOrRoot
      // const saveImprovementsAccess = this.saveImprovementsCondition || saveImprovementsByAdmin
      // const save = editAnyAccess && (this.saveInActiveStateCondition || saveRemarksAccess || saveImprovementsAccess)
      //
      // console.log('User: ', reportRoles.user.name)
      // console.log('Actions Access: ', JSON.stringify(actionsAccess))
      // console.log('Edit Any: ', editAnyAccess)
      // console.log('Save InActiveState: ', this.saveInActiveStateCondition)
      //
      // console.log('Edit Remarks: ', this.saveRemarksCondition)
      // console.log('Save Remarks - btn: ', saveRemarksAccess)
      //
      // console.log('Save Improvements as Executor: ', this.saveImprovementsCondition)
      // console.log('Save Improvements as Admin: ', saveImprovementsByAdmin)
      // console.log('Save Improvements: ', saveImprovementsAccess)
      //
      // console.log('SAVE: ', saveImprovementsByAdmin)
      //
      // return save // TODO save - condition + !disabledSaveChangesButton

        return (this.editData || this.editRemarks) &&
        ((this.saveRemarksCondition && (stateId == 'PR3' || stateId == 'PR4' || stateId == 'PR7' || stateId == 'PR9' || stateId == 'PR10')) ||
        this.saveImprovementsCondition ||
        this.saveInActiveStateCondition ||
        (this.improvementsCommonDisplayCondition && stateId !== 'PR8' && (reportRoles.roleAdminOrRoot || this.assigningContractorDispatcher)))
      }
    },
    setRemarkImportant: {
      get: function () {
        return reportRoles.isImportantRemarksAdmin || reportRoles.isImportantRemarksOperator
      }
    },
    editImportantRemarks: {
      get: function () {
        return reportRoles.isImportantRemarksAdmin
      }
    },
    PR3_displayReadyToCheckButton: {
      get: function () {
        return stateId == 'PR11' && this.editData
      }
    },
    PR4_displayAcceptButton: {
      get: function () {
        return stateId == 'PR3' &&
        !(bpStateId == 'BS4' || bpStateId == 'BS5' || bpStateId == 'BS6' || bpStateId == 'BS7' || bpStateId == 'BS14' || bpStateId == 'BS15') &&
        reportRoles.roleDispatcherOrHigher
      }
    },
    PR7_displayVerifiedNoCommentsButton: {
      get: function () {
      // TODO save - condition
        return this.improvementsCommonDisplayCondition &&
        ((stateId == 'PR4' || stateId == 'PR10') && reportRoles.roleReportCheckerOrHigher)
      }
    },
    PR8_displayVerifiedHaveCommentsButton: {
      get: function () {
      // TODO save - condition + !this.reworkReportByExecutor
        return !!this.reworkReportByExecutor || !!this.reworkReportAssignment || // TODO assignmentAccess
        (this.improvementsCommonDisplayCondition &&
          ((stateId == 'PR4' || stateId == 'PR7' || stateId == 'PR10') && (reportRoles.roleDispatcherOrHigher || reportRoles.roleReportCheckerOrHigher)))
      }
    },
    PR9_displayFixingProblemsButton: {
      get: function () {
      // TODO save - condition + stateId === 'PR8'
        return this.improvementsCommonDisplayCondition &&
        ((stateId == 'PR8' && (this.editData || this.editRemarks)) || // 8=>9 Сохранить
          (stateId == 'PR10' && reportRoles.hasImprovementsExecutorAccess)) // 10=>9 Вернуться к доработке
      }
    },
    PR9_displayFixingProblemsWithReadyToRecheckButton: {
      get: function () {
      // TODO save - condition + stateId === 'PR8'
        return this.improvementsCommonDisplayCondition &&
        (stateId == 'PR8' && reportRoles.hasResponsibleImprovementsExecutorAccess)
      }
    },
    PR10_displayReadyToRecheckButton: {
      get: function () {
      // TODO save - condition
        return this.improvementsCommonDisplayCondition &&
        (stateId == 'PR9' && reportRoles.hasResponsibleImprovementsExecutorAccess)
      }
    }
  })
}

// Получение свойств отчёта ==========

export function getReportProperties (report, savedReportProperties, includeOnlyChanges, includeMaterials) {
  const save = !!savedReportProperties

  const properties = {}

  // Работы
  const worksChanges = getReportWorksProperty(report.workTypes, report.workPackages, save, includeOnlyChanges, report.workTypesToRemove, report)
  if (!includeOnlyChanges || worksChanges.worksToSave.length) {
    properties.works = worksChanges.worksToSave
  }

  // Работы подрядчика
  const worksChangesContractor = getReportWorksProperty(report.workTypesContractor, report.workPackagesContractor, save, includeOnlyChanges, report.workTypesToRemoveContractor, report)
  if (!includeOnlyChanges || worksChangesContractor.worksToSave.length) {
    properties.worksContractor = worksChangesContractor.worksToSave
  }

  // Общий комментарий
  if (!includeOnlyChanges || isStringPropertyChanged(report.comment, savedReportProperties.comment)) {
    properties.comment = report.comment
  }

  // Отключение общего признака регистрации важных замечаний
  if (!includeOnlyChanges || report.cancelVerifiedReportHasImportantRemarks !== savedReportProperties.cancelVerifiedReportHasImportantRemarks) {
    properties.cancelVerifiedReportHasImportantRemarks = report.cancelVerifiedReportHasImportantRemarks
  }

  // Замечания:
  // Замечания общие к секции фото
  if (!includeOnlyChanges || JSON.stringify(report.remarks) !== JSON.stringify(savedReportProperties.remarks)) {
    properties.remarks = report.remarks
  }
  // Замечания  к  конкретному фото
  if (!includeOnlyChanges || JSON.stringify(report.imagesRemarks) !== JSON.stringify(savedReportProperties.imagesRemarks)) {
    properties.imagesRemarks = report.imagesRemarks
  }
  // Замечание общее к чек-листу
  if (!includeOnlyChanges || JSON.stringify(report.commonRemark) !== JSON.stringify(savedReportProperties.commonRemark)) {
    properties.commonRemark = report.commonRemark
  }

  if (!includeOnlyChanges) {
    properties.gosNumber = report.gosNumber
    properties.garageNumber = report.garageNumber
  } else if (report.selectedVehiclesSearchFormatted) {
    const savedGosNumber = savedReportProperties.gosNumber ? savedReportProperties.gosNumber.split(' / ').sort().join(' / ') : ''
    const savedGarageNumber = savedReportProperties.garageNumber ? savedReportProperties.garageNumber.split(' / ').sort().join(' / ') : ''

    const changedGosNumber = report.selectedVehiclesSearchFormatted ? report.selectedVehiclesSearchFormatted.map(vehicle => vehicle.gosNumber).sort().filter(Boolean).join(' / ') : ''
    const changedGarageNumber = report.selectedVehiclesSearchFormatted ? report.selectedVehiclesSearchFormatted.map(vehicle => vehicle.garageNumber).sort().filter(Boolean).join(' / ') : ''

    if (changedGosNumber !== savedGosNumber || changedGarageNumber !== savedGarageNumber) {
      properties.vehicles = report.selectedVehiclesSearchFormatted.map(vehicle => vehicle.id)
    }
  }

  // Автовышки - TODO delete - теперь сохранение осуществляется через отдельные сервисы сразу же при изменении
  // const forkliftTrucks = report.forkliftTrucks.map(forkliftTruck => {
  //   const forkliftTruckData = { id: forkliftTruck.id }
  //   const properties = forkliftTruck._properties
  //   if (properties) {
  //     Object.assign(forkliftTruckData, properties)
  //   }
  //   return forkliftTruckData
  // })
  // if (!save || JSON.stringify(forkliftTrucks) !== JSON.stringify(savedReportProperties.forkliftTrucks)) {
  //   properties.forkliftTrucks = forkliftTrucks
  // }
  // if (!includeOnlyChanges || report.forkliftTrucksAbsent !== savedReportProperties.forkliftTrucksAbsent) {
  //   properties.forkliftTrucksAbsent = report.forkliftTrucksAbsent
  // }
  // if (!includeOnlyChanges || isStringPropertyChanged(report.forkliftTrucksComment, savedReportProperties.forkliftTrucksComment)) {
  //   properties.forkliftTrucksComment = report.forkliftTrucksComment
  // }

  if (report.reports) { // свойства сводного отчёта
    const reportsProperties = []
    report.reports.forEach(reportItem => {
      let reportItemSaved = null
      if (includeOnlyChanges) {
        reportItemSaved = savedReportProperties.reports.find(reportItemSaved => reportItemSaved.id === reportItem.id)
      }

      const requestId = report.requestId[reportItem.id]
      const singleReportProperties = getSingleReportProperties(reportItem, includeOnlyChanges, reportItemSaved, worksChanges, worksChangesContractor, requestId, includeMaterials)
      if (Object.keys(singleReportProperties).length !== 0) {
        singleReportProperties.id = reportItem.id
        reportsProperties.push(singleReportProperties)
      }
    })

    if (reportsProperties.length) {
      properties.reports = reportsProperties
    }
  } else { // свойства обычного отчёта
    const requestId = report.requestId
    const singleReportProperties = getSingleReportProperties(report, includeOnlyChanges, savedReportProperties, worksChanges, worksChangesContractor, requestId, includeMaterials)
    Object.assign(properties, singleReportProperties)
  }
  return properties
}

function getSingleReportProperties (report, includeOnlyChanges, savedReportProperties, worksChanges, worksChangesContractor, requestId, includeMaterials) {
  const properties = {}

  if (includeOnlyChanges) {
    // Удаляемые работы
    const worksToRemove = worksChanges.worksToRemove[requestId]
    if (worksToRemove.length) {
      properties.worksToRemove = worksToRemove
    }
    // Удаляемые работы подрядчика
    const worksToRemoveContractor = worksChangesContractor.worksToRemove[requestId]
    if (worksToRemoveContractor.length) {
      properties.worksToRemoveContractor = worksToRemoveContractor
    }
  }

  // Замечания по материалам
  if (!includeOnlyChanges || JSON.stringify(report.demountingRemarks) !== JSON.stringify(savedReportProperties.demountingRemarks)) {
    properties.demountingRemarks = report.demountingRemarks
  }
  if (!includeOnlyChanges || JSON.stringify(report.mountingRemarks) !== JSON.stringify(savedReportProperties.mountingRemarks)) {
    properties.mountingRemarks = report.mountingRemarks
  }
  if (!includeOnlyChanges || JSON.stringify(report.debitRemarks) !== JSON.stringify(savedReportProperties.debitRemarks)) {
    properties.debitRemarks = report.debitRemarks
  }
  if (!includeOnlyChanges || JSON.stringify(report.consumptionRemarks) !== JSON.stringify(savedReportProperties.consumptionRemarks)) {
    properties.consumptionRemarks = report.consumptionRemarks
  }

  // Проект
  const projectId = report.project ? report.project.id : null
  if (!includeOnlyChanges || projectId != savedReportProperties.project) {
    properties.project = projectId
  }

  // Автосписание из типовой спецификации
  if (typeof report.autoDebits === 'boolean') {
    if (!includeOnlyChanges || report.autoDebits !== savedReportProperties.autoDebits) {
      properties.autoDebits = report.autoDebits
    }
  }

  // Материалы
  if (includeMaterials) {
    report._materialsGroups.applyChanges(properties)
  }

  return properties
}

function getReportWorksProperty (workTypes, workPackages, save, includeOnlyChanges, worksToRemove, report) {
  const allWorks = [...workTypes]
  for (let i = 0; i < workPackages.length; i++) {
    workPackages[i].workTypes.forEach((work) => {
      allWorks.push(work)
    })
  }

  const worksIdsToRemoveFully = worksToRemove.map(work => work.id)
  const worksIdsToRemove = {}
  if (report.reports) {
    report.reports.forEach(reportItem => {
      worksIdsToRemove[report.requestId[reportItem.id]] = worksIdsToRemoveFully.slice()
    })
  } else {
    worksIdsToRemove[report.requestId] = worksIdsToRemoveFully
  }

  const worksToSave = []
  allWorks.forEach(work => {
    const clearedWork = getClearedWork(work)
    if (includeOnlyChanges) {
      if (work._initial) { // не добавленная работа только что работа
        // TODO && !work.hasChanges()
        let hasRequestsChanges = false
        if (clearedWork.requests && JSON.stringify(clearedWork.requests) !== JSON.stringify(work._initial.requests)) {
          let isToRemove = false
          for (const requestId of work._initial.requests) {
            if (!clearedWork.requests.includes(requestId)) {
              worksIdsToRemove[requestId].push(work.id)
              isToRemove = true
            }
          }
          if (!isToRemove) {
            hasRequestsChanges = true
          }
        }
        const hasIncludedInCurrentReportChanges = JSON.stringify(clearedWork.includedInCurrentReport) !== JSON.stringify(work._initial.includedInCurrentReport)
        if (!hasRequestsChanges && !clearedWork.hasDataChanges(work._initial) && !hasIncludedInCurrentReportChanges) {
          return
        }
      }
    }

    worksToSave.push(clearedWork)
  })
  return {
    worksToSave,
    worksToRemove: worksIdsToRemove
  }
}

function getClearedWork (work) {
  const clearedWork = {
    id: work.id,
    key: work.key, // для проверок на запрет добавления
    name: work.name, // TODO определять на сервере !!!
    done: work.done,
    comment: work.comment,
    includedInCurrentReport: work.includedInCurrentReport,
    technologicalOperations: work.technologicalOperations.map(operation => getClearedTechnologicalOperation(operation)),
    hasDataChanges: function (workOld) {
      return this.done !== workOld.done || //
      work.dublicated ||
      isStringPropertyChanged(this.comment, workOld.comment) || //
      JSON.stringify(this.technologicalOperations) !== JSON.stringify(workOld.technologicalOperations)
    }
  }
  if (work.requests) {
    clearedWork.requests = work.requests
  }
  return clearedWork
}

function getClearedTechnologicalOperation (operation) {
  return {
    id: operation.id,
    key: operation.key,
    index: operation.index,
    name: operation.name, // TODO определять на сервере
    done: operation.done, // Boolean
    comment: operation.comment, // String
    remark: operation.remark, // Boolean
    remarkComment: operation.remarkComment, // String
    remarkDone: operation.remarkDone, // Boolean
    remarkImportant: operation.remarkImportant, // Boolean
    required: operation.required, // Boolean - TODO определять на сервере !!!
    resultsRequired: operation.resultsRequired, // Boolean - TODO определять на сервере !!!
    objectUpdated: operation.objectUpdated, // Boolean
    workResultsTypes: operation.workResultsTypes.map(workResultsType => getClearedWorkResultsType(workResultsType))
  }
}

function getClearedWorkResultsType (workResultsType) {
  const workResultsTypeCleared = {
    id: workResultsType.id,
    key: workResultsType.key,
    name: workResultsType.name,
    // brigadesIds
    resultValues: workResultsType.resultValues.map(resultValue => getClearedWorkResultValue(resultValue))
  }

  if (workResultsType.brigadesIds && workResultsType.brigadesIds.length) {
    workResultsTypeCleared.brigadesIds = workResultsType.brigadesIds // NON_EMPTY
  }

  return workResultsTypeCleared
}

function getClearedWorkResultValue (resultValue) {
  let innerValue = resultValue.value
  if (innerValue) {
    if (resultValue.fieldType == 'location') { // string to number
      innerValue = [[getClearedCoordinateValue(innerValue[0][0]), getClearedCoordinateValue(innerValue[0][1])]]
    }
  }

  return {
    id: resultValue.id, // Number | String
    code: resultValue.code,
    value: innerValue, // Object
    objectUpdated: resultValue.objectUpdated // Boolean
  }
}

function getClearedCoordinateValue (value) {
  if (value) {
    if (typeof value === 'number') {
      return Number(value.toFixed(6))
    } else {
      return Number(value)
    }
  } else if (value === '' || value === undefined) {
    return null
  }
  return value
}

function prepareCoordinateValue (value) {
  if (value == null) {
    return ''
  } else if (typeof value === 'number') {
    return value.toFixed(6)
  }
  return value
}

function isStringPropertyChanged (value, savedValue) {
  if (value) {
    return value !== savedValue
  }
  return !!savedValue
}

function getMaterialsSourceReport (report, work) {
  let materialsSourceReport = null
  if (report.reports && report.multiReport) {
    if (work.requests && work.requests.length) {
      const requestId = work.requests[0]
      const multiReportRequest = report.multiReport.items.find(item => item.requestId === requestId)
      if (multiReportRequest) {
        materialsSourceReport = report.reports.find(multiReportItem => multiReportItem.id === multiReportRequest.reportId)
      }
    }
  } else {
    materialsSourceReport = report
  }
  return materialsSourceReport
}

export const DEFAULT_REPORT_IMAGES_CATEGORIES = [
  { key: 'dispatcher', name: 'Фото из заявки' },
  { key: 'vehicle', name: 'Парковка и выгородка ТС' },
  { key: 'video', name: 'Видео' },
  { key: 'additionalVehicles', name: 'Дополнительная техника' },
  { key: 'beforeWorkExecution', name: 'До выполнения работ' },
  { key: 'duringWorkExecution', name: 'В процессе выполнения работ' },
  { key: 'afterWorkExecution', name: 'После выполнения работ' },
  { key: 'audit', name: 'Аудит' },
  { key: 'advertisements', name: 'Рекламные объявления' },
  { key: 'forAuditRequest', name: 'Замечания по аудиту' },
  { key: 'other', name: 'Другое' }
]

export const DEFAULT_REPORT_IMAGES_CATEGORIES_MAP = (function () {
  const categoriesMap = {}
  for (const category of DEFAULT_REPORT_IMAGES_CATEGORIES) {
    categoriesMap[category.key] = category
  }
  return categoriesMap
})()
